<template>
    <div class="af-searchbar-inner-container afu-flex afu-flex-row afu-mb-6">
        <div class="afu-w-1/3">
            <div class="af-keyword-search afu-block afu-border afu-border-solid afu-appearance-none afu-w-full afu-transition afu-duration-150 afu-ease-in-out afu-text-black afu-leading-5 afu-border-gray-400 afu-bg-white afu-py-2 afu-px-3 searchbar-height">
                <div class="label-wrapper afu-mb-0">
                    <label for="search-keywork-input afu-mb-0">
                        Keywords
                    </label>
                </div>
                <input
                    id="search-keywork-input"
                    class="afu-border-none afu-w-full focus:afu-outline-none afu-placeholder-gray-600 afu-text-base"
                    v-model="keyword"
                    :placeholder="$t('label.search_keyword')"
                    @keyup.enter="handleSearch()"
                >
            </div>
        </div>

        <div class="afu-mb-4 md:afu-mb-0 md:afu-w-1/3 md:afu-mr-4">
            <div class="searchbar-height">
                <ClassificationSelecter @updateClassification="searchClassification" />
            </div>
        </div>

        <div class="afu-w-1/3 afu-flex afu-justify-end">
            <div class="af-location-search afu-block afu-border afu-border-solid afu-appearance-none afu-w-2/3 afu-transition afu-duration-150 afu-ease-in-out afu-text-black afu-leading-5 afu-border-gray-400 afu-bg-white afu-py-2 afu-px-3 afu-mr-2 searchbar-height">
                <div class="label-wrapper afu-mb-0">
                    <label for="search-keywork-input afu-mb-0">
                        Location
                    </label>
                </div>
                <C1Typeahead
                    v-model="location.label"
                    class="searchbar-typeahead w-100 afu-border-none"
                    naked
                    :is-busy="spinner.location"
                    :options="locationOptions"
                    :no-icon="true"
                    :search-min-length="2"
                    label-key="label"
                    value-key="id"
                    filter-by="label"
                    :placeholder="$t('label.select_location')"
                    @search="searchLocations"
                    @hit="onLocationSelect"
                    @keyup.enter="handleSearch()"
                >
                    <template slot="noResults">
                        <div>
                            No matching locations found.
                        </div>
                    </template>
                </C1Typeahead>
            </div>
            <div class="afu-w-1/3">
                <C1Button
                    type="button"
                    variant="primary"
                    class="search-submit searchbar-height"
                    @click.stop.prevent="handleSubmit()"
                >
                    {{ $t('label.search_jobs') }}
                </C1Button>
            </div>
        </div>
    </div>
</template>

<script>
    import C1Button from '@/components/C1Components/C1Button';
    import C1Typeahead from '@/components/C1Components/C1Typeahead';
    import ClassificationSelecter from '@/components/C1Components/ClassificationSelecter';

    export default {
        name: 'Searchbar',

        components: {
            C1Button,
            C1Typeahead,
            ClassificationSelecter,
        },

        data() {
            return {
                keyword: '',
                location: {},
                category: {},
                classifications: [],
                locations: [],
                locationOptions: [],
                spinner: {
                    location: false,
                },
            };
        },

        mounted() {},

        computed: {
            emitData() {
                return {
                    keyword: this.keyword,
                    classifications: this.classifications,
                    location: this.location,
                };
            },
        },

        methods: {
            getLocations() {
                this.$axios.$get('v1/site/locations').then(response => {
                    this.locations = response.data;
                    this.locationOptions = [...this.locations];
                });
            },

            searchClassification(classifications) {
                this.classifications = classifications;
            },

            searchLocations(str) {
                this.spinner.location = true;
                const keyword = str.toLowerCase();
                const searchResults = this.locations.filter(loc => {
                    if (loc.label.toLowerCase().includes(keyword)) {
                        return loc;
                    }
                });

                this.locationOptions = [...searchResults];
                this.spinner.location = false;
            },

            onLocationSelect(location) {
                this.location = location;
            },

            handleSubmit() {
                this.$emit('hit', this.emitData);
            },
        },
    };
</script>
<style lang="scss" scoped>
    #search-keywork-input {
        font-size: 14px;
        padding: 0;
    }

    .label-wrapper {
        label {
            font-weight: bold;
            font-size: 12px;
            line-height: 13px;
            letter-spacing: 2px;
            text-transform: uppercase;
            color: #224468; //secondary
            margin: 0;
        }
    }

    .af-location-search {
        &::v-deep {
            input {
                border: 0;
                padding: 0;
                font-size: 14px;
                line-height: inherit;
                height: auto;
            }
        }
    }

    .search-submit {
        border-radius: 0;
    }

    .searchbar-height {
        height: 58px;
        box-sizing: border-box;
    }
</style>
